import css from './EventList.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Breakpoints } from 'meta/layout/breakpoints'
import { CollectionFromIframe } from 'meta/pages/collection'

import { Grid, GridColumn } from 'components/Layout/Grid'
import { MockCollectionAnchorable } from 'components/Pages/Collection/mock'

import EventListItemContainer from './EventListItem/EventListItemContainer'
import NoEvents from './NoEvents/NoEvents'
import PerformerListItemContainer from './PerformerListItem/PerformerListItemContainer'

interface IProps {
  isPerformer?: boolean
  eventCodes: string[]
}

const EventList: React.FC<MockCollectionAnchorable & CollectionFromIframe & IProps> = (props) => {
  const { eventCodes, anchorId, fromIframe, toggleContent, isPerformer } = props

  const { t } = useTranslation()

  if (eventCodes.length === 0) {
    return null
  }

  return (
    <Grid>
      <GridColumn gridColumnStart={1} gridColumnEnd={{ [Breakpoints.tablet]: 17, [Breakpoints.mobile]: 17 }}>
        <div className={css.eventListContainer}>
          <h2 className={css.title} id={anchorId}>
            {t('collection:event_title')}
          </h2>

          {eventCodes.map((code, key) => {
            if (isPerformer) {
              return (
                <PerformerListItemContainer
                  eventCode={code}
                  key={key}
                  fromIframe={fromIframe}
                  toggleContent={toggleContent}
                />
              )
            } else {
              return (
                <EventListItemContainer
                  eventCode={code}
                  key={key}
                  fromIframe={fromIframe}
                  toggleContent={toggleContent}
                />
              )
            }
          })}

          {eventCodes.length == 0 && <NoEvents />}
        </div>
      </GridColumn>
    </Grid>
  )
}

export default EventList
